import DetailsDialogController from '../../controllers/DetailsDialogController.js'

export default class AccessListDetailController extends DetailsDialogController {
  constructor ($mdDialog, ManagementService, ToastService) {
    'ngInject'
    super(...arguments)
    this.populateRelations(this.entity, 'acl')
  }
}
